<!-- @format -->

<ng-container *transloco="let t">
  <fudis-dialog [size]="'sm'">
    <fudis-dialog-content>
      <fudis-form
        [titleVariant]="'lg'"
        [title]="t('STUDY_PLAN_CREATE_NEW_LONG')"
        [level]="2"
        [errorSummaryTitle]="t('PLAN.CREATE_PLAN_MODAL.ERROR_SUMMARY')">
        <fudis-form-content>
          <fudis-grid [rowGap]="'sm'" [classes]="'fudis-mb-md'">
            <sis-tab-content-switch
              [tabs]="tabs"
              [currentIndex]="selectedTabIndex"
              (currentIndexChange)="openTab($event)"></sis-tab-content-switch>
            @if (data$ | async; as data) {
              <fudis-select
                [control]="form.controls.education"
                [selectionClearButton]="false"
                [placeholder]="selectedTabIndex === 0 ? t('SIS_COMPONENTS.SELECT.CHOOSE') : t('SIS_COMPONENTS.SELECT.SEARCH_OR_SELECT')"
                [label]="t('PLAN.CREATE_PLAN_MODAL.FIELDS.EDUCATION')"
                [variant]="selectedTabIndex === 0 ? 'dropdown' : 'autocompleteDropdown'">
                <ng-template *ngIf="selectedTabIndex === 0" fudisSelectOptions>
                  @for (option of data.educationOptions; track option.value.id) {
                    <fudis-select-option [data]="option" />
                  }
                </ng-template>
                <ng-template *ngIf="selectedTabIndex === 1" fudisSelectOptions>
                  @for (option of allEducationOptions; track option.value.id) {
                    <fudis-select-option [data]="option" />
                  }
                </ng-template>
              </fudis-select>
              <fudis-select
                *ngIf="selectedTabIndex === 1"
                [control]="form.controls.learningOpportunityId"
                [selectionClearButton]="false"
                [placeholder]="t('SIS_COMPONENTS.PLAN.CREATE_PLAN.SELECT_LEARNING_OPPORTUNITY_PLACEHOLDER')"
                [label]="t('SIS_COMPONENTS.PLAN.CREATE_PLAN.LABEL_LEARNING_OPPORTUNITY')">
                <ng-template fudisSelectOptions>
                  @for (option of learningOpportunityOptions; track option.value) {
                    <fudis-select-option [data]="option" />
                  }
                </ng-template>
              </fudis-select>
              <fudis-select
                [label]="t('PLAN.CREATE_PLAN_MODAL.FIELDS.CURRICULUM_PERIOD')"
                [placeholder]="t('SIS_COMPONENTS.SELECT.CHOOSE')"
                [selectionClearButton]="false"
                [control]="form.controls.curriculumPeriod">
                <ng-template fudisSelectOptions>
                  @for (option of data.curriculumPeriodOptions; track option.value.id) {
                    <fudis-select-option [data]="option" />
                  }
                </ng-template>
              </fudis-select>
              <fudis-text-input [label]="t('PLAN.CREATE_PLAN_MODAL.FIELDS.NAME')" [control]="form.controls.name"> </fudis-text-input>
            }
          </fudis-grid>
        </fudis-form-content>
        <fudis-form-actions>
          <fudis-button fudisDialogClose [label]="t('SIS_COMPONENTS.BUTTON.CANCEL')" [variant]="'secondary'" />
          <fudis-button
            fudisFormSubmit
            [formValid]="form.valid"
            [label]="t('PLAN.CREATE_PLAN_MODAL.SUBMIT_BUTTON')"
            (handleClick)="submitSubject$.next()" />
        </fudis-form-actions>
      </fudis-form>
    </fudis-dialog-content>
  </fudis-dialog>
</ng-container>
